import React from "react";

function accClass(pct) {
  if (pct === null || pct === undefined) return "";
  if (pct >= 90) return "sc-stat--acc-high";
  if (pct >= 70) return "sc-stat--acc-mid";
  return "sc-stat--acc-low";
}

/**
 * Compact progress overview for an active stock check session.
 *
 * Props
 *   totals       — { totalItems, totalExpectedUnits, totalScannedUnits }
 *   statusCounts — { completed, pending, extra } (derived from items)
 *   unknownCount — number of unknown barcode scans
 *   report       — optional report object (when session is COMPLETED, manager only)
 */
function StockCheckProgressBar({ totals, statusCounts = {}, unknownCount = 0, report }) {
  const completed = statusCounts.completed ?? 0;
  const pending   = statusCounts.pending   ?? 0;
  const extra     = statusCounts.extra     ?? 0;
  const total     = totals?.totalItems     ?? 0;

  const scanPct = total > 0 ? Math.min(100, Math.round((completed / total) * 100)) : 0;

  const accuracyPct = report?.summary?.inventoryAccuracyPct  ?? null;
  const availPct    = report?.summary?.availabilityAccuracyPct ?? null;

  return (
    <div>
      <div className="sc-progress-track">
        <div
          className={`sc-progress-fill${scanPct >= 100 ? " sc-progress-fill--full" : ""}`}
          style={{ width: `${scanPct}%` }}
        />
      </div>

      <div className="sc-stats">
        <div className="sc-stat sc-stat--completed">
          <span className="sc-stat__value">{completed}</span>
          <span className="sc-stat__label">Done</span>
        </div>
        <div className="sc-stat sc-stat--remaining">
          <span className="sc-stat__value">{pending}</span>
          <span className="sc-stat__label">Left</span>
        </div>
        <div className="sc-stat sc-stat--extra">
          <span className="sc-stat__value">{extra}</span>
          <span className="sc-stat__label">Extra</span>
        </div>
        <div className="sc-stat sc-stat--unknown">
          <span className="sc-stat__value">{unknownCount}</span>
          <span className="sc-stat__label">Unknown</span>
        </div>

        {accuracyPct !== null && (
          <div className={`sc-stat ${accClass(accuracyPct)}`}>
            <span className="sc-stat__value">{accuracyPct}%</span>
            <span className="sc-stat__label">Inv. Acc.</span>
          </div>
        )}
        {availPct !== null && (
          <div className={`sc-stat ${accClass(availPct)}`}>
            <span className="sc-stat__value">{availPct}%</span>
            <span className="sc-stat__label">Avail.</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default StockCheckProgressBar;
